import React, { Component, useEffect, useState } from 'react'
import moment from 'moment';
import { Spinner, TabFilter } from '../common/Helper';
import { useParams, useSearchParams } from 'react-router-dom'
import { formatSecs } from '../../lib/utils'
import IssueGroup, { IssueGroupView } from '../perf/IssueGroup';
import { useSelector } from 'react-redux';
import { useConf, useUserTicketGrouper } from '../../lib/hooks';
const Member = () => {

    const [sp] = useSearchParams();
    let { username } = useParams();
    const userInfo = useSelector(st => st.userInfo);
    if (!username) {
        username = userInfo?.username;
    }

    const { groupedList } = useUserTicketGrouper(username);

    let filter = sp.get('filter');
    if (!filter) {
        filter = 'all'
    }

    let count = 0;
    let content = null;
    let totalEstimate = 0;
    let totalSpent = 0;

    if (groupedList == null || !username) {
        content = <Spinner />;
    } else {
        const views = groupedList.reduce((acc, item) => {
            item.filter(filter);
            acc.push(<IssueGroupView key={item.uname} group={item} filter={filter} />);
            return acc;
        }, []);
        content = <div className="issue-board">{views}</div>;
    }

    if (groupedList) {
        totalEstimate = groupedList.reduce((acc, i) => acc + i.totalEstimate, 0);
        totalSpent = groupedList.reduce((acc, i) => acc + i.totalSpent, 0);
    }

    const { workflow } = useConf();
    const filters = ['All', 'Pending', ...workflow, 'Spill'];
    return (
        <div>
            <div className="page-head">
                <h2>{username}</h2>
                <span className="page-head__stat ds-nums">{formatSecs(totalSpent)} / {formatSecs(totalEstimate)}</span>
            </div>

            <TabFilter filters={filters} name='filter' count={count} />

            <div style={{ marginTop: 'var(--ds-space-5)' }}>
                {content}
            </div>
        </div>
    );

}

export default Member;
